import React from "react";
import { useState, useEffect } from "react";
import "./SignUp.css";
import { auth } from "../../Firebase";
import { useAuth } from "../../Context/authContext";
import { useNavigate, Link } from "react-router-dom";

// *** Remember to use "useNavigate" from react router *** //

import {
  addDoc,
  getDoc,
  getFirestore,
  setDoc,
  doc,
  collection,
} from "firebase/firestore";

import {
  createUserWithEmailAndPassword,
  
} from "firebase/auth";

import { async } from "@firebase/util";

const db = getFirestore();

// Collection Reference

const id_colRef = collection(db, "IDgen");
const map_colRef = collection(db, "Maps");
// const uid_colRef = collection(db, "UID");
// Document reference
const count_docRef = doc(id_colRef, "counter");

// Accommodation Counter
const acc_colRef = collection(db, "StayCounter"); // changed
const acc_docRef = doc(acc_colRef, "yesCounter"); // changed

const SignUp = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  useEffect(() => {
    setTimeout(() => {
      setOpen(false);
      setAccom(false);
    }, 5000);
    if (currentUser) {
      navigate("/");
    }
  });
 
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [college, setCollege] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [stay, setStay] = useState("No");
  const [password, setPassword] = useState("");
  const [accom,setAccom] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
   
  
 



  const handleSubmit = async (e) => {
    e.preventDefault();

    let curr;
    let stayCurr; // changed
    let isValid=true;
    let errorMsg="";

    if(name.length==0)
    {
    isValid=false;
    errorMsg="Please enter a valid Name"
    }
    else if(contact.length!=10 )
    {
      isValid=false;
      errorMsg="Please enter a valid Contact Number"
    }
    else if(email.length==0 && !email.includes("@"))
    {
      isValid=false;
      errorMsg="Please enter a valid Email"

    }
    else if(password.length<=6){
      isValid=false;
      errorMsg="Password must contain minimum of 6 characters"
        }
    else if(college.length==0)
     {
      isValid=false;
      errorMsg="Please enter a valid School/College name"
     }
    else if(city.length==0)
     {
      isValid=false;
      errorMsg="Please enter a valid city name"
     }
     else if(state.length==0)
     {
      isValid=false;
      errorMsg="Please enter a valid state name"
     }
     if(!isValid)
     {
      setOpen(true);
      setMessage(errorMsg);
      return
     }

    await createUserWithEmailAndPassword(auth, email, password)
      .then(async () => {
        console.log("User Registered");
        setMessage("User Registered");
        navigate("/login");
        // Fetching count value

        const docData = await getDoc(count_docRef);
        const { value } = docData.data();
        curr = Number(value) + 1;
        // console.log(curr);

        if (stay === "Yes") {
          // changed
          const stayData = await getDoc(acc_docRef); //  changed
          const { stayValue } = stayData.data(); //   changed
          stayCurr = Number(stayValue) + 1; //    changed
          console.log(stayCurr); //     changed

          // Accommodation counter set

          await setDoc(acc_docRef, {
            //      changed
            stayValue: stayCurr,
          });
          console.log("Stay counter set"); //        changed
        }

        // Update count value and push user details
        await setDoc(count_docRef, { value: curr }).then(() => {
          let id = String(curr); // Custom ID
          setDoc(doc(db, "Participant", id), {
            Name: name,
            Contact: contact,
            Email: email,
            College: college,
            City: city,
            State: state,
            Stay: stay,
          }).then(async () => {
            setCity("");
            setCollege("");
            setContact("");
            setEmail("");
            setName("");
            setState("");
            setStay("");
            setPassword("");
            console.log("Pushed");


            // UID

            await setDoc(doc(db, "UID", email), {
              uid: id,
            });
            console.log("UID set");

            // Maps

            await addDoc(map_colRef, {
              custom: id,
            });
            console.log("Mapped");
          });
        });
      }) // End of .then() of createUserWithEmailAndPassword
      .catch(() => {
        setOpen(true);
        setMessage("User already Registered. Please login to continue.");
      });
  };
  return (
    <div className="signup-overlay">
      <div className="signup-container">
        <form className="signup-form">
          <h1 className="heading signup">
            SIGN UP <div className="bottom_line"></div>
          </h1>
          {open && (
            <div
              className="note"
              style={{
                width: "80%",
                fontSize: "0.9rem",
                padding: "0.4rem",
                marginTop: "-1rem ",
                marginBottom: "-0.2rem ",
                textAlign:"center"
              }}
            >
              <span style={{ textAlign: "center" }}>{message}</span>
            </div>
          )}

          <input
            name="name"
            value={name}
            type="text"
            onChange={(e) => setName(e.target.value)}
            placeholder="Name"
            className="input-field"
            required
          />
          <input
            name="contact"
            value={contact}
            type="text"
            onChange={(e) => setContact(e.target.value)}
            placeholder="Contact No"
            className="input-field"
            required
          />
          <input
            name="email"
            value={email}
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="input-field"
            required
          />
          <input
            name="password"
            value={password}
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="input-field"
            required
          />
          <input
            name="college"
            value={college}
            type="text"
            onChange={(e) => setCollege(e.target.value)}
            placeholder="College/School Name"
            className="input-field"
            required
          />
        
          <input
            name="city"
            value={city}
            type="text"
            onChange={(e) => setCity(e.target.value)}
            placeholder="City"
            className="input-field"
            required
          />
          <input
            name="state"
            value={state}
            type="text"
            onChange={(e) => setState(e.target.value)}
            placeholder="State"
            className="input-field"
            required
          />
          <div className="checkbox">
            <h4 className="heading">Accommodation facility required?</h4>

            <label className="container">
              Yes
              <input
                name="stay"
                type="radio"
                value="Yes"
                checked={stay=="Yes"}
                onChange={(e) => {setStay(e.target.value);setAccom(true)}}
                placeholder=""
              />
              <span class="checkmark"></span>
            </label>
            <label className="container">
              No
              <input
                name="stay"
                value="No"
                type="radio"
                checked={stay=="No"}
                onChange={(e) => setStay(e.target.value)}
                placeholder=""
              />
              <span class="checkmark"></span>
            </label>
          </div>
          {accom && <div
            className="note"
            style={{
              width: "80%",
              fontSize: "1rem",
              padding: "0.5rem",
              margin: "-1rem ",
              textAlign:"center"
            }}
          >
           
             <p>
              <span>NOTE:</span>Accommodation is subject to availability
            </p>
          </div>
          }
          <div className="input-bot">
            <h4>
              <Link to="/login">Login?</Link>
            </h4>
           
            <button
              type="submit"
              className="button-62"
              onClick={(e) => handleSubmit(e)}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignUp;
